// extracted by mini-css-extract-plugin
export default {"root":"Button_root__j5CKF","p-disabled":"Button_p-disabled__c7eQQ","loading":"Button_loading__2RI7O","outlined":"Button_outlined__gq+aU","text":"Button_text__7U-98"};